import { useContext } from 'react'
import { SelectedDateContext, SelectedDateDispatchContext } from './context'

export function useSelectedDate() {
  const context = useContext(SelectedDateContext)
  if (context === undefined) {
    throw new Error(
      'useSelectedDate must be used within a SelectedDateProvider'
    )
  }
  return context
}

export function useSelectedDateDispatch() {
  const context = useContext(SelectedDateDispatchContext)
  if (context === undefined) {
    throw new Error(
      'useSelectedDateDispatch must be used within a SelectedDateProvider'
    )
  }
  return context
}
